<aix-number
    [config]="config"
    [isStandalone]="false"
    [isRequired]="templateData.fieldIsRequired"
    [isDisabled]="templateData.fieldIsDisabled"
    [isDirty]="templateData.fieldIsDirty"
    [isValid]="!templateData.ctrlIsInvalid"
    [aixDynamicNextPendingField]="{ config: config }"
    [allowDecimal]="config.allowDecimal ?? false"
    [allowNegative]="config.allowNegative ?? true"
    [allowCommas]="config.allowCommas ?? false"
    [decimalLimit]="config.decimalLimit ?? 2"
    [initialValue]="value"
    [hint]="config?.hint ?? ''"
    (setDirty)="setDirty()"
    (valueChanges)="valueChange($event)"
>
    {{ config.label }}
</aix-number>

@if (templateData.canDisplayErrors) {
<div class="form-error--container">
    <div
        class="form-error"
        title="{{ templateData.ctrlErrors | aixFormErrors }}"
        [data-testing]="config.refId! + '_validation_error'"
    >
        {{ templateData.ctrlErrors | aixFormErrors : config.label }}
    </div>
</div>
}
